/**
 * Created by hejikun on 2017/10/30 0030.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import common from './common'

Vue.use(Vuex)

const requireComponent = require.context('./modules', true, /\.js$/)
let modules = {}

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName)

  const componentName = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')
  modules[componentName] = componentConfig.default || componentConfig
})
let store = new Vuex.Store({
  modules,
  mutations: common.mutations,
  actions: common.actions,
  state: common.state,
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      paths: ['registration.registration_order']
    })
  ]
})

window.$store = store

export default store
